import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { HOURS, PHONE_DISPLAY, PHONE_TEL } from "@/constants/site";

const LegalLayout = ({ title, updated, intro, sections }) => (
  <div className="bg-white">
    <div className="bg-gradient-to-b from-amber-50/80 to-white border-b border-slate-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
        <p className="text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase text-amber-600">
          Legal
        </p>
        <h1 data-testid="legal-title" className="mt-4 font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
          {title}
        </h1>
        <p className="mt-4 text-sm text-slate-500">
          {updated} · Swarajya Solar Services ·{" "}
          <a href={PHONE_TEL} data-testid="legal-call-link" className="font-semibold text-orange-600 hover:text-orange-700">
            {PHONE_DISPLAY}
          </a>
        </p>
      </div>
    </div>
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <p className="text-base leading-relaxed text-slate-600">{intro}</p>
      <div className="mt-12 space-y-10">
        {sections.map((s, i) => (
          <section key={i} data-testid={`legal-section-${i + 1}`}>
            <h2 className="font-display text-xl sm:text-2xl font-bold tracking-tight text-slate-900 flex items-baseline gap-3">
              <span className="font-mono text-sm text-orange-600">{String(i + 1).padStart(2, "0")}</span>
              {s.heading}
            </h2>
            <div className="mt-4 space-y-3">
              {s.body.map((p, j) => (
                <p key={j} className="text-base leading-relaxed text-slate-600">{p}</p>
              ))}
              {s.list && (
                <ul className="space-y-2 mt-3">
                  {s.list.map((li, j) => (
                    <li key={j} className="flex gap-3 text-base leading-relaxed text-slate-600">
                      <span className="mt-2.5 h-1.5 w-1.5 rounded-full bg-orange-500 shrink-0" />
                      {li}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </section>
        ))}
      </div>
      <div className="mt-16 rounded-3xl bg-slate-950 text-white p-8 sm:p-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div>
          <h2 className="font-display text-2xl font-bold">Questions about this policy?</h2>
          <p className="mt-2 text-slate-300 text-sm">Call us at {PHONE_DISPLAY}, {HOURS}.</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
          <a
            href={PHONE_TEL}
            data-testid="legal-cta-call-button"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-orange-600 px-6 py-3 text-sm font-semibold text-white hover:bg-orange-700 transition-colors"
          >
            <Phone className="h-4 w-4" /> Call {PHONE_DISPLAY}
          </a>
          <Link
            to="/contact"
            data-testid="legal-cta-quote-button"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-slate-700 px-6 py-3 text-sm font-semibold text-white hover:border-orange-500 transition-colors"
          >
            Get Free Quote <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default LegalLayout;
